import React from 'react'
import { IconButton, Spacer } from '@chakra-ui/react'
import { ChevronLeftIcon } from '@chakra-ui/icons'
import {
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerHeader,
    DrawerBody,
    ModalOverlayProps,
} from '@chakra-ui/react'

import { PatientFieldsFragment } from '~graphql/generated/graphql'
import DetailedPatientInfo from './detailed-patient-info'
import { ModalProps } from '@chakra-ui/react'
import LoadingView from '~components/shared/loading-view'
import OpenChatButton from '~components/shared/open-chat-button'
import SyncIndividualPatientButton from '~components/shared/patient/sync-from-pims-button'

interface Props extends Omit<ModalProps, 'children'> {
    patient?: PatientFieldsFragment
    loading?: boolean
    overlayOverrides?: ModalOverlayProps
}

export default function PatientDetailsDrawer({
    patient,
    isOpen,
    onClose,
    loading,
    overlayOverrides,
    ...props
}: Props) {
    return (
        <Drawer
            isOpen={isOpen}
            onClose={onClose}
            placement="right"
            size="lg"
            blockScrollOnMount={false}
            {...props}
        >
            <DrawerOverlay {...overlayOverrides} />
            <DrawerContent>
                <DrawerHeader
                    pb={4}
                    shadow="blue.md"
                    display="flex"
                    justifyContent="space-between"
                    gap={3}
                >
                    <IconButton
                        size="sm"
                        icon={<ChevronLeftIcon fontSize="xl" />}
                        variant="outline"
                        rounded="full"
                        aria-label="Close Modal"
                        onClick={onClose}
                    />
                    <Spacer />
                    {patient && (
                        <>
                            {patient.owner && (
                                <OpenChatButton
                                    client={patient.owner}
                                    patient={patient}
                                    size="sm"
                                >
                                    Open chat
                                </OpenChatButton>
                            )}
                            <SyncIndividualPatientButton patient={patient} />
                        </>
                    )}
                </DrawerHeader>
                <DrawerBody px={{ base: 2, md: 6 }} py={{ base: 4, md: 6 }}>
                    {loading ? (
                        <LoadingView />
                    ) : (
                        <DetailedPatientInfo patient={patient} />
                    )}
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}
